import { render, staticRenderFns } from "./text-banner.vue?vue&type=template&id=541e8b4e&scoped=true&"
import script from "./text-banner.vue?vue&type=script&lang=js&"
export * from "./text-banner.vue?vue&type=script&lang=js&"
import style0 from "./text-banner.vue?vue&type=style&index=0&id=541e8b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e8b4e",
  null
  
)

export default component.exports